import { getPlatform, Platforms } from '@cloudnoa/cloud-platform'

const platform = Object.assign({}, getPlatform(window.servicePlatform))
Platforms.forEach((p) => {
  platform[`is${p.capitalizedId}`] = p.id === platform.id
})

export default {
  service: {
    platform: window.servicePlatform,
    env: window.serviceEnv,
  },

  platform,

  title: {
    text: `HyperBilling for ${platform.shortName}`,
    suffix: '',
  },

  logo: {
    dir: '/img/logo',
    filename: `${platform.id}.png`,
    alt: `HyperBilling for ${platform.name}`,
  },

  api: {
    baseUri: '/api',
  },

  router: {
    mode: 'history',
  },

  serviceStartDate: '2019-01-01',

  feature: {
    project: true,
    tags: true,
    creditAlarm: true,
    budgetAlarm: true,
    reseller: false,
    report: false,
    costByRegion: true,
    costByCountry: false,
    creditKind: false,
    pricingUnit: false,
    showExchangeRate: true,
    showProjectId: false,
    accountBalance: false,
    accountText: 'account',
    projectText: 'project',
    globalCorporation: false,
  },

  topNavigation: {
    showAccountId: false,
    minAccountForSearch: 10,
    minAccountForPin: 20,
  },

  invoice: {
    title: platform.shortName,
  },

  billing: {
    root: window.location.origin,

    summary: {
      dataPresentHours: 5.5 + 24, // 한국 시간 기준 오후 2시 30분 (UTC 5시 30분) 이후에 하루전 데이터가 존재한다고 가정함
      dataCompleteHours: 5.5 + 48, // 한국 시간 기준 오후 2시 30분 (UTC 5시 30분) 이후에 이틀 전 데이터가 완전하다고 가정함
      maxRegressionWindow: 30, // 선형 회귀에 사용할 최대 데이터 수
      minRegressionWindow: 3, // 선형 회귀에 사용할 최소 데이터 수

      costShareItems: [
        'costByCountry',
        'costByRegion',
        'costByProject',
        'costByService',
      ],
    },

    dataTransfer: {
      enabled: true,
    },

    costPivot: {
      excludeFields: [],
    },

    cdn: {
      enabled: true,
    },

    consolidated: {
      enabled: true,
    },

    commitmentAnalysis: {
      enabled: false,
    },
    costTable: {
      enabled: false,
    },
  },

  personal: {
    ipAccessControl: {
      enabled: false,
    },
  },

  admin: {},

  reseller: {
    enabled: false,
  },

  socket: {
    uri: '/',

    option: {
      path: '/api/socket/worker',
      transports: ['websocket'],
      timeout: '30000',
    },

    event: {
      worker: 'workerService',
    },
  },

  megazoneAccount: {
    url: 'https://start.megazone.com/',
  },

  storage: {
    billing: {
      path: `/${platform.id}/billing/`,
    },
  },

  exchangeRate: {
    default: 'USD',
  },

  languages: {
    default: 'ko',

    korean: {
      enabled: true,
      name: 'korean',
      value: 'ko',
    },
    english: {
      enabled: true,
      name: 'english',
      value: 'en',
    },
  },

  currencies: {
    default: 'KRW',

    krw: {
      enabled: true,
      name: 'krw',
      value: 'KRW',
      unit: '₩',
    },
    usd: {
      enabled: true,
      name: 'usd',
      value: 'USD',
      unit: '$',
    },
    cny: {
      enabled: false,
      name: 'cny',
      value: 'CNY',
      unit: '¥',
    },
    jpy: {
      enabled: false,
      name: 'jpy',
      value: 'JPY',
      unit: '¥',
    },
  },

  bq: {
    accounts: [],
  },

  corporations: {
    international: {
      enabled: false,
      name: 'international',
      value: 'international',
      ordering: 1,
    },
    china: {
      enable: false,
      name: 'china',
      value: 'china',
      ordering: 2,
    },
    hongkong: {
      enabled: false,
      name: 'hongkong',
      value: 'hongkong',
      ordering: 3,
    },
    australia: {
      enabled: false,
      name: 'australia',
      value: 'australia',
      ordering: 4,
    },
  },

  timezone: 'UTC',

  ga: {
    hasGoogleAnalytics: false,
    trackingId: window.trackingId || '',
  },
}
